module.exports = __webpack_public_path__ + "static/media/download.5ed1f8a4.svg";